// extracted by mini-css-extract-plugin
export default {"resultsContainer":"ActivityResults_resultsContainer__i25Lu","resultItem":"ActivityResults_resultItem__ATJD+","results":"ActivityResults_results__+mDeD"};